import React /*, { useState, useEffect }*/ from 'react';
import { siteUrl } from "../../../utils/siteUrl";
import './breadcrumb.scss';


const Breadcrumb = props => {

  // const [activeCategorySlug, setCategorySlug] = useState('');
  // const [activeCategoryTitle, setCategoryTitle] = useState('');

  // useEffect(() => {

  //     if (typeof window !== `undefined`) {
  //         setCategorySlug(sessionStorage.getItem("slugFilter"));
  //         setCategoryTitle(sessionStorage.getItem("titleFilter"));
  //         return
  //     }else{
  //         setCategorySlug('lo-ultimo');
  //         setCategoryTitle('Lo Último');
  //         return
  //     }
  // })

  // if(!props.mobile){
  //     if(props.article){
  //         return (

  //             <div className="f-breadcrumb-container">

  //                 {props.elements.map((element, index) => {
  //                     return (
  //                         <div key={index} className="f-breadcrumb-element">
  //                             <a className="f-link f-link-breadcrumb" href={"/" + element.slug}>{element.titulo}</a>
  //                             <span className="f-breadcrumb-separator">/</span>
  //                         </div>

  //                     )
  //                 })}
  //                 <div className="f-breadcrumb-element">

  //                     <a className="f-link f-link-breadcrumb" href={"/" + props.sitioPadre.slug}>{props.sitioPadre.titulo}</a>
  //                 </div>
  //                 <span className="f-breadcrumb-separator">/</span>

  //                 {/* {props.categorias.map((categoria,index) =>
  //                     <span key={index}>
  //                         {index > 0 && activeCategorySlug === 'lo-ultimo' ? <span className="f-breadcrumb-separator">-</span> : null}
  //                         {activeCategorySlug === 'lo-ultimo' ? <span>{categoria.titulo}</span> : null}
  //                     </span>
  //                 )}
  //                 {activeCategorySlug !== 'lo-ultimo' ? <div className="f-breadcrumb-element">
  //                     <a className="f-link f-link-breadcrumb" href={"/" + props.sitioPadre.slug}>{activeCategoryTitle}</a>
  //                 </div> : null}

  //                 <span className="f-breadcrumb-separator">/</span> */}
  //                 <span className="f-current-site">{props.titlePage}</span>
  //             </div>
  //         )

  //     }else{

  //         return (

  //             <div className="f-breadcrumb-container">

  //                 {props.elements.map((element, index) => {
  //                     return (
  //                         <div key={index} className="f-breadcrumb-element">
  //                             <a className="f-link f-link-breadcrumb" href={"/" + element.slug}>{element.titulo}</a>
  //                             <span className="f-breadcrumb-separator">/</span>
  //                         </div>

  //                     )
  //                 })}
  //                 <span className="f-current-site">{props.titlePage}</span>
  //             </div>
  //         )
  //     }

  // }else{
  //     return null
  // }

  const camelize = (str) => {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toUpperCase() : word.toUpperCase();
    }).replace(/\s+/g, '').replace(/-/g, ' ');
  }

  var isBrowser = typeof window !== 'undefined'

  var path = isBrowser ? window.location.pathname : '/'
  var elements = path.split('/')
  elements.shift()

  if (elements[elements.length - 1] === '') elements.pop()

  if (!props.mobile) {
    return (

      <div className="f-breadcrumb-container">
        <div className="f-breadcrumb-element">
          <a className="f-link f-link-breadcrumb" href={siteUrl + '/'}>Inicio</a>
        </div>

        {elements.map((element, index) => {

          var fullPath = ''
          elements.map((elementPath, indexPath) => indexPath <= index ? fullPath += elementPath + '/' : '')

          if (index < elements.length - 1) {

            return (
              <div key={index} className="f-breadcrumb-element">
                <span className="f-breadcrumb-separator">/</span>
                <a className="f-link f-link-breadcrumb" href={siteUrl + '/' + fullPath}>{camelize(element)}</a>
              </div>

            )

          } else {
            return (
              <div key={index} className="f-breadcrumb-element">
                <span className="f-breadcrumb-separator">/</span>
                <span className="f-current-site">{camelize(element)}</span>
              </div>

            )
          }
        })}
      </div>
    )
  } else {
    return null
  }
}

export default Breadcrumb
